import React, {useEffect, useState} from "react";
import {
    CustomInput,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Nav,
    NavItem,
    NavLink, Row,
    TabContent,
    TabPane
} from "reactstrap";
import "easymde/dist/easymde.min.css";

import ActionButton from "./save-button";
import {cloneObject, errorlog, extractErrorMessage, getLastElementOr, renderlog, showlog} from "../utils";
import {
    editAndSaveChoiche,
    editAndSaveQuestion,
    getQuestion,
    loadSiScoringChoiche,
    saveChoiche,
    saveQuestion
} from "../business-logic/rating";
import {WaitingOrNodataMessage} from "./waiting-or-nodata-message";

import Select from "react-select";
import {setFlagToLanguage, translate} from "./i18n/translate-function";
import {LANGUAGES} from "../conf/languages";
import {setCertificationRequired} from "../services/request-manager";


export const ConfirmCertificationModal = props => {


    renderlog("ConfirmCertificationModal");

    const [setError, error] = useState()

    return (
        <Modal isOpen={true} toggle={() => props.onClose()}>
            <ModalHeader className={"question-edit-modal-header-container"}>
                <span>{translate("Confirm")}</span>

                <div>
                    <ActionButton
                        color={"link"}
                        buttonText={translate("Cancel")}
                        promise={() => {
                            return Promise.resolve();
                        }}
                        onResult={toggleEvent => props.onClose()}
                    />
                    <ActionButton
                        buttonText={translate("Confirm")}
                        promise={() => setCertificationRequired(props.evaluationId, props.isCertificationRequired)}
                        onResult={result => {
                            // wait( false );
                            props.onClose(true);
                        }}
                        onError={err => {
                            showlog('err', err);

                            // setError(err)
                        }}
                        className={'srtool-edit-modal-button'}
                    />
                </div>

            </ModalHeader>
            <ModalBody>

                <div className={"question-edit-modal-header-container"}>
                    Sei sicuro di voler {props.isCertificationRequired ? "confermare" : "annullare"} la richiesta di
                    certificazione?
                </div>


            </ModalBody>
            {
                !!error &&
                <ModalFooter className={"edit-question-modal-footer"}>
                    <span className={"error-message-label"}>{error}</span>
                </ModalFooter>
            }
        </Modal>
    );
}

